module.exports = __webpack_public_path__ + "static/media/Twodash_gray.cf116fd0.svg";